import moment from 'moment';
import { useEffect } from "react";
import styled from "styled-components";
import { toast } from 'react-toastify';
import React, { useState } from 'react';
import { useSelector } from "react-redux";
import XrCardAv from '../../../components/XrCardAv.tsx';
import XrTextAv from '../../../components/XrTextAv.tsx';
import XrButtonAv from '../../../components/XrButtonAv.tsx';
import XrDataTable from '../../../components/XrDataTable.tsx';
import { useLocation, useNavigate } from 'react-router-dom';
import BootstrapGrid from '../../../components/BootstrapGrid.tsx';
import { apiGet, API_URL_BOOKING } from "../../../helpers/api.ts";
import { parseEnumStatus } from '../../../helpers/parseEnum';

const ManageBookingPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const token = useSelector((state) => state.authentication.token);
  const authorizedUser = useSelector((state) => state.authentication.authorizedUser);
  const [isLoading, setLoading] = useState(false);
  const [booking, setBooking] = useState(null);

  const populateData = async () => {
    if (!authorizedUser || isLoading) return;
    setLoading(true);
    try {
      const paths = location.pathname.split("/");
      const id = parseInt(paths[2]);
      if (id && !isNaN(id)) {
        const request = await apiGet(API_URL_BOOKING.SELECT_BOOKING(id), token);
        const result = await request.json();
        setBooking(result.data);
      } else {
        navigate(`/submissions`);
      }
    } catch (e) {
      toast.error('Terjadi kesalahan pada server, mohon coba kembali.');
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    populateData();
  }, [])

  useEffect(() => {
    populateData();
  }, [authorizedUser])

  const printDocument = () => {
    window.print();
  }

  if (!booking) return <div />

  return (
    <ManageBookingPageWrapper>
      <BootstrapGrid>
        <div className='requestBooking'>
          <XrCardAv style={{ width: '100%' }}>
            <div className="card--title">
              <div className="card--title requestBooking__toolbar">
                <div>
                  <XrTextAv tag='h2' variant='title'>
                    Konfirmasi Peminjaman
                  </XrTextAv>
                  <XrTextAv tag='p' variant='description'>
                    Mohon periksa kembali bahwa informasi berikut sudah benar.
                  </XrTextAv>
                </div>
              </div>
            </div>
            <div className="card--body">
              <div className='row'>
                <div className='col-sm-6'>
                  <XrTextAv tag='p' variant='description'>
                    Nama Kegiatan
                  </XrTextAv>
                  <XrTextAv tag='p' variant='body'>
                    {booking.description}
                  </XrTextAv>

                  <br />
                  <XrTextAv tag='p' variant='description'>
                    Estimasi Jumlah Peserta
                  </XrTextAv>
                  <XrTextAv tag='p' variant='body'>
                    {booking.estimate_participant}
                  </XrTextAv>

                  <br />
                  <XrTextAv tag='p' variant='description'>
                    Tanggal Meminjam
                  </XrTextAv>
                  <XrTextAv tag='p' variant='body'>
                    {moment(booking.start_date).format('DD MMMM YYYY')}
                  </XrTextAv>

                  <br />
                  <XrTextAv tag='p' variant='description'>
                    Waktu Kegiatan
                  </XrTextAv>
                  <XrTextAv tag='p' variant='body'>
                  {moment(booking.start_date).format('HH:MM')} — {moment(booking.end_date).format('HH:MM')}
                  </XrTextAv>

                  <br />
                  <XrTextAv tag='p' variant='description'>
                    Catatan
                  </XrTextAv>
                  <XrTextAv tag='p' variant='body'>
                    {booking.notes || 'Tidak ada catatan'}
                  </XrTextAv>
                </div>
                <div className='col-sm-6'>
                  <XrTextAv tag='p' variant='description'>
                    Nama Pemohon
                  </XrTextAv>
                  <XrTextAv tag='p' variant='body'>
                    {booking.user_detail.name}
                  </XrTextAv>

                  <br />
                  <XrTextAv tag='p' variant='description'>
                    Organisasi Pemohon
                  </XrTextAv>
                  <XrTextAv tag='p' variant='body'>
                    {booking.user_detail.role_detail.role_name}
                  </XrTextAv>

                  <br />
                  <XrTextAv tag='p' variant='description'>
                    Nama Peminjam
                  </XrTextAv>
                  <XrTextAv tag='p' variant='body'>
                    {booking.issuer_name}
                  </XrTextAv>

                  <br />
                  <XrTextAv tag='p' variant='description'>
                    Nomor Telepon Peminjam
                  </XrTextAv>
                  <XrTextAv tag='p' variant='body'>
                    {booking.issuer_phone}
                  </XrTextAv>

                  <br />
                  <XrTextAv tag='p' variant='description'>
                    Organisasi Peminjam
                  </XrTextAv>
                  <XrTextAv tag='p' variant='body'>
                    {booking.role_detail.role_name}
                  </XrTextAv>
                </div>
              </div>

              <br/>
              <XrTextAv tag='p' variant='description' spaceBottom='5'>
                Ruangan yang Ingin Dipinjam
              </XrTextAv>
              <XrDataTable style={{ marginTop: 0, marginBottom: '20px' }}>
                <div className="tablewrapper--table">
                  <table>
                    <thead>
                      <tr>
                        <th>Nama</th>
                        <th>Kapasitas</th>
                        <th>Status</th>
                        <th>Keterangan</th>
                      </tr>
                    </thead>
                    <tbody>
                      {booking.rooms.map(room => {
                        return (
                          <tr>
                            <td>{room.room_detail?.room_name}</td>
                            <td>{room.room_detail?.room_capacity}</td>
                            <td>{parseEnumStatus(room.status)}</td>
                            <td>{room.description ? room.description : '-'}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </XrDataTable>

              <br/>
              <XrTextAv tag='p' variant='description' spaceBottom='5'>
                Inventaris yang Ingin Dipinjam
              </XrTextAv>
              <XrDataTable style={{ marginTop: 0, marginBottom: '20px' }}>
                <div className="tablewrapper--table">
                  <table>
                    <thead>
                      <tr>
                        <th>Nama</th>
                        <th>Jumlah</th>
                        <th>Status</th>
                        <th>Keterangan</th>
                      </tr>
                    </thead>
                    <tbody>
                      {booking.inventories.map(inventory => {
                        return (
                          <tr>
                            <td>{inventory.inventory_detail?.item_name}</td>
                            <td>{inventory.quantity}</td>
                            <td>{parseEnumStatus(inventory.status)}</td>
                            <td>{inventory.description ? inventory.description : '-'}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </XrDataTable>

              <br/><br/>
              <div className='d-print-none'>
                <p>Anda dapat mencetak bukti peminjaman setelah proses pengajuan selesai.</p>

                <XrButtonAv
                  noBlock
                  size='large'
                  color='primary'
                  onClick={printDocument}
                  isLoading={isLoading}
                  style={{ marginTop: '5px' }}
                  caption={`Cetak Bukti Peminjaman`}
                />
              </div>
            </div>
          </XrCardAv>
        </div>
      </BootstrapGrid>
    </ManageBookingPageWrapper>
  )
}

const ManageBookingPageWrapper = styled.div`
  & .requestBooking {
    display: flex;
    margin: 0 auto;
    margin-top: 50px;
    max-width: 800px;
  }
`;

export default ManageBookingPage;